export const formats = {
  dateFormat: 'M/d/yy',
  dateLongFormat: 'M/d/yyyy',

  dateTimeFormat: 'M/d/y h:mm aa',
  dateTimeLongFormat: 'M/d/yyyy h:mm aa',

  dateTimeSecondsFormat: 'M/d/yy h:mm:ss aa',
  dateTimeSecondsLongFormat: 'M/d/yyyy h:mm:ss aa',

  dateTime24Format: 'M/d/yy HH:mm',
  dateTime24LongFormat: 'M/d/yyyy HH:mm',

  dateTime24SecondsFormat: 'M/d/yy HH:mm:ss',
  dateTime24SecondsLongFormat: 'M/d/yyyy HH:mm:ss',

  reportDate: 'MM/dd/yyyy',
  reportDateTime: 'MM/dd/yyyy HH:mm:ss',

  timeFormat: 'h:mm aa',
  timeFormatLong: 'h:mm:ss aa',

  time24Format: 'HH:mm',
  time24FormatLong: 'HH:mm:ss',

  primeNgDateFormat: 'mm/dd/y',
  primeNgDateLongFormat: 'mm/dd/yy',
  primeNgTime12Format: '12',
  primeNgTime24Format: '24',
} as const;
